/**
 * Compact "My Work" strip for non-compliance users — shows count of items requiring action.
 */
import React from 'react';

export default function MyWorkStrip({ count, onClick }) {
  if (count === 0) return null;
  return (
    <div className="flex items-center justify-between px-4 py-2.5 bg-indigo-50/80 border border-indigo-200/80 rounded-xl">
      <span className="text-sm text-indigo-800">
        <span className="font-semibold">{count}</span> item{count !== 1 ? 's' : ''} require your action
      </span>
      {onClick && (
        <button
          type="button"
          onClick={onClick}
          className="text-sm font-medium text-indigo-600 hover:text-indigo-800"
        >
          View →
        </button>
      )}
    </div>
  );
}
